import { request } from "@umijs/max";

export enum MessageStatus {
  Unread,
  Read,
}

export interface IGetMessageDto {
  userId: string;
  userIds: string[];
  current: number;
  size: number;
  status: MessageStatus;
  teamId: string;
}

export interface IMessage {
  content: string;
  id: string;
  messageTime: string;
  title: string;
}

export function getMessagesService(dto: Partial<IGetMessageDto>) {
  return request<API.BaseListResponse<IMessage>>(
    "/api/damselfish-central-backend/innerMessage/query",
    {
      method: "POST",
      data: dto,
    }
  );
}

export function readMessageService(dto: Partial<IGetMessageDto>, id?: string) {
  return request<API.BaseResponse>(
    "/api/damselfish-central-backend/innerMessage/have-read",
    {
      method: "POST",
      data: dto,
      params: {
        id,
      },
    }
  );
}
